import { NewPeriodSelectorIntervalType } from '../../enums/newPeriodSelectorIntervalType';
import { NewPeriodFilter } from './newPeriodFilter';

export class NewCropCyclePeriodFilter extends NewPeriodFilter {
  periodIntervalType = NewPeriodSelectorIntervalType.CropCycle;
  intervalLength: number;
}
